import { render, staticRenderFns } from "./BotServiceMetadataListCard.vue?vue&type=template&id=dad2cf04"
import script from "./BotServiceMetadataListCard.vue?vue&type=script&lang=ts"
export * from "./BotServiceMetadataListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports